import React from "react";

function BedIcon(props: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.25 5.25H8.25V10.5H2.25V3.75H0.75V15H2.25V12.75H15.75V15H17.25V8.25C17.25 7.45435 16.9339 6.69129 16.3713 6.12868C15.8087 5.56607 15.0456 5.25 14.25 5.25ZM5.25 9.75C5.84674 9.75 6.41903 9.51295 6.84099 9.09099C7.26295 8.66903 7.5 8.09674 7.5 7.5C7.5 6.90326 7.26295 6.33097 6.84099 5.90901C6.41903 5.48705 5.84674 5.25 5.25 5.25C4.65326 5.25 4.08097 5.48705 3.65901 5.90901C3.23705 6.33097 3 6.90326 3 7.5C3 8.09674 3.23705 8.66903 3.65901 9.09099C4.08097 9.51295 4.65326 9.75 5.25 9.75Z"
        fill="#91A4B7"
      />
    </svg>
  );
}

export default BedIcon;
